import { forwardRef } from 'react';
import { Switch } from '@headlessui/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ToggleInput = /*#__PURE__*/forwardRef(function ToggleInput(_ref, ref) {
  var value = _ref.value,
      label = _ref.label,
      name = _ref.name,
      disabled = _ref.disabled,
      onChange = _ref.onChange;

  var handleChange = function handleChange(e) {
    if (!disabled) {
      onChange(e);
    }
  };

  return /*#__PURE__*/_jsx(Switch.Group, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "toggle-input flex items-center",
      children: [/*#__PURE__*/_jsxs(Switch, {
        ref: ref,
        checked: value,
        className: "".concat(value && !disabled ? 'bg-brand-primary' : 'bg-gray-200', " relative inline-flex h-6 w-11 shrink-0 items-center rounded-full outline-none transition"),
        onChange: handleChange,
        children: [/*#__PURE__*/_jsx("span", {
          className: "label sr-only"
        }), /*#__PURE__*/_jsx("span", {
          className: "".concat(value ? 'translate-x-6' : 'translate-x-1', " inline-block h-4 w-4 transform rounded-full bg-white transition")
        })]
      }), /*#__PURE__*/_jsx(Switch.Label, {
        className: "p-small ml-3 cursor-pointer select-none",
        passive: disabled,
        children: label
      })]
    })
  });
});